<template>
  <div class="follow-resource">
    <div v-if="!detailShow" class="main-content">
      <div class="top-line">
        <div
          class="small-button"
          style="margin-right: 20px"
          @click="navigateBack"
        >
          返回
        </div>
        <span class="title">我的关注</span>
      </div>
      <div class="table-container">
        <el-table :data="data" style="width: 100%; margin-bottom: 10px">
          <el-table-column label="作者" align="center">
            <template slot-scope="scope">
              <div class="info-line">
                <img
                  class="avatar"
                  :src="
                    scope.row.created_user_avatar ||
                    require('../../../images/teacherCover.png')
                  "
                  alt=""
                />
                <div>
                  <div class="info-text">{{ scope.row.created_user }}</div>
                  <div class="info-text">{{ scope.row.school_name }}</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="title"
            label="资源标题"
            width="width"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="tag"
            label="资源标签"
            width="width"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="type"
            label="文件类型"
            width="width"
            align="center"
          >
            <template slot-scope="scope">{{
              getFileType(scope.row.urls)
            }}</template>
          </el-table-column>
          <el-table-column
            prop="updated_at"
            label="更新时间"
            width="width"
            align="center"
          ></el-table-column>
          <el-table-column label="浏览/收藏/下载" width="200" align="center">
            <template slot-scope="scope">
              <div class="data">
                <div class="data-item">
                  <img
                    class="data-icon"
                    style="width: 17px; height: 12px"
                    :src="require('../../assets/view.png')"
                    alt=""
                  />
                  {{ getDisplayCount(scope.row.views || 0) }}
                </div>
                <div class="data-item">
                  <img
                    class="data-icon"
                    style="width: 15px; height: 14px"
                    :src="require('../../assets/collect.png')"
                    alt=""
                  />
                  {{ getDisplayCount(scope.row.collect || 0) }}
                </div>
                <div class="data-item">
                  <img
                    class="data-icon"
                    style="width: 14px; height: 14px"
                    :src="require('../../assets/download.png')"
                    alt=""
                  />
                  {{ getDisplayCount(scope.row.download || 0) }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" fixed="right">
            <template slot-scope="scope">
              <div style="display: flex; justify-content: center">
                <div class="small-button" @click="toDetail(scope.row.id)">
                  查看
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="page"
          background
          @current-change="onPageChange"
          :current-page="page"
          :page-size="10"
          layout="prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getFileType } from '../../utils/utils'
import { getResource } from '../../api/api'
export default {
  name: 'FollowResource',
  data: () => ({
    detailShow: false,
    data: [],
    page: 1,
    total: 0,
  }),
  mounted() {
    this.search()
  },
  methods: {
    getFileType,
    getDisplayCount(num) {
      if (num > 9999) {
        return Math.floor(num / 1000) / 10 + 'w'
      } else {
        return num
      }
    },
    navigateBack() {
      this.$router.back()
    },
    search() {
      getResource({ page: this.page, follow: 1, status: 0 }).then((res) => {
        this.data = res.data.data.list
        this.total = res.data.data.total
      })
    },
    onPageChange(e) {
      this.page = e
      this.search()
    },
    toDetail(id) {
      this.$router.push(`bookResource?id=${id}`)
    },
  },
}
</script>

<style lang="less" scoped>
.follow-resource {
  padding: 0 40px 40px;
  .top-line {
    display: flex;
    height: 81px;
    align-items: center;
  }
  .small-button {
    width: 56px;
    height: 24px;
    border-radius: 12px;
    border: 1px solid #00aeff;
    text-align: center;
    line-height: 24px;
    font-size: 14px;
    color: #00aeff;
    user-select: none;
    cursor: pointer;
  }
  .title {
    font-size: 18px;
    color: #4d4d4d;
    margin-left: 20px;
  }
  .table-container {
    position: relative;
    box-sizing: border-box;
    min-height: calc(100vh - 221px);
    padding: 20px 20px 50px 20px;
    background-color: #fff;
  }
  .page {
    position: absolute;
    right: 20px;
    bottom: 14px;
  }
  .info-line {
    display: flex;
  }
  .avatar {
    width: 50px;
    height: 50px;
    margin-right: 8px;
    border-radius: 50%;
  }
  .info-text {
    font-size: 14px;
    color: #4c4c4c;
  }
  .data {
    display: flex;
    justify-content: center;
    align-items: center;
    .data-item {
      margin-right: 29px;
      font-size: 14px;
      color: #4c4c4c;
      &:last-child {
        margin-right: 0;
      }
      .data-icon {
        margin-right: 4px;
      }
    }
  }
}
</style>
